import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {usePermissionsFailureGuard} from "../../../hooks/usePermissionsFailureGuard.ts";
import {rbacActions} from "../../../config/rbac/actions.ts";
import {IndexPage} from "./pages/IndexPage.tsx";
import {AddPage} from "./pages/AddPage.tsx";
import {EditPage} from "./pages/EditPage.tsx";


export const OrganizationsLayout = () => {

    const {allowedActions} = useVerifiedPermissions()
    usePermissionsFailureGuard() // Interim until FNP-1749


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes(rbacActions.GetOrganization) ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path='add'
                element={
                    allowedActions.includes(rbacActions.CreateOrganization) ? (
                        <AddPage/>
                    ) : (
                        <Navigate to='/organizations'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes(rbacActions.GetOrganization) ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/organizations'/>
                    )
                }

            >
            </Route>


        </Routes>
    );
};
